import { AccordionContent, AccordionProduct } from "@foodpilot/foods";
import { ProductFormProductIngredient } from "src/pages/Product/ProductForm/ProductForm.types";
import { LineTitle } from "./LineTitle";
import { LineContent } from "./LineContent";

type IngredientAccordionProps = {
    ingredients: ProductFormProductIngredient[];
    setProductIngredients: (newIngredients: ProductFormProductIngredient[]) => void;
};
export const IngredientAccordion = (props: IngredientAccordionProps) => {
    const { ingredients, setProductIngredients } = props;

    const pages: AccordionContent[] = ingredients.map((ingredient) => {
        return {
            title: (
                <LineTitle
                    ingredient={ingredient}
                    setIngredient={(newIngredient) => {
                        const newIngredientList = ingredients.map((ing) => {
                            // Comparer par @id en gérant à la fois les ingrédients et les produits intermédiaires
                            const ingId = ing.ingredient?.["@id"] ?? ing.intermediateProduct?.["@id"];
                            const newIngId =
                                newIngredient.ingredient?.["@id"] ?? newIngredient.intermediateProduct?.["@id"];

                            if (ingId === newIngId) {
                                return newIngredient;
                            }
                            return ing;
                        });
                        setProductIngredients(newIngredientList);
                    }}
                />
            ),
            content: <LineContent ingredient={ingredient} />,
        };
    });
    return <AccordionProduct pages={pages} />;
};
